export default {
    packages_tab_title: 'Packages',
    packages_tab_add_packages: 'Add Package',
    packages_tab_name: 'Name',
    packages_tab_project: 'Platform',
    packages_tab_dealer: 'Brand',
    packages_tab_created_at: 'Created At',
    packages_tab_edit: 'Edit',
    packages_tab_account: 'Account',
    packages_tab_assigned: 'Assigned',
    packages_tab_temaple: '* Template'
};
